
<div class="fds">
  <row>
    <column>
      <label for="account-relation-selection">
        Who can view this record on their dashboard?
        <help-tooltip>
          Select Account relationships that can also view this model's records on their dashboard.
        </help-tooltip>
      </label>
    </column>
  </row>

  <div class="mb-2">
    <button @click="buttonClicked" class="btn input-color dropdown-toggle arrow full-sz text-left">
      Select accounts...
    </button>

    <context-menu
      ref="contextMenu"
      :state="modalStateFor(vueModalID.dynamicContentPopup)"
      :index="vueModalID.dynamicContentPopup"
      fixed
      @close="hideModal(vueModalID.dynamicContentPopup)"
    >
      <deterministic-dynamic-fields-tree
        :fields-handler="fieldsHandler"
        unsearchable
        @select="handleSelect"
      />
    </context-menu>
  </div>

  <chip-list
    :chips="referencePaths"
    display-key="dynamicFieldName"
    :rootId="selectedObjectModel.client_id"
    @destroy="handleDestroy"
    pill-color="Sepia"
  ></chip-list>
</div>
